export default {
  title: 'Gebyrer',
  subtitle: 'Servicegebyr pr. restaurant for {{company}}.',
  card_title: 'Servicegebyr',
  banner: {
    default_summary: 'Partnerstandard: {{percentage}} % · min. {{min}} · maks. {{max}}.',
    override_hint: 'Tilsidesæt nedenfor for at angive et andet gebyr for denne restaurant.',
    suggested_summary: 'Foreslåede startværdier: {{percentage}} % · min. {{min}} · maks. {{max}}.',
    suggested_hint: 'Juster dem nedenfor, og gem for at opkræve servicegebyr hos denne restaurant.',
    own_fee_hint: 'Denne restaurant opkræver sit eget gebyr, angivet nedenfor.',
    saved_summary: 'Dine sidst gemte værdier: {{percentage}} % · min. {{min}} · maks. {{max}}.',
    saved_hint: 'Servicegebyret er slået fra. Gem disse værdier, eller ændr dem først, for at slå det til igen.',
  },
  form: {
    recommended: 'Anbefalet: {{value}}',
    percentage: {
      label: 'Servicegebyr i procent',
      tooltip: 'Procentdel af ordreværdien, der opkræves af gæsten som servicegebyr.',
    },
    min_amount: {
      label: 'Minimum servicegebyr',
      tooltip: 'Beregnede gebyrer under dette beløb rundes op til det.',
    },
    max_amount: {
      label: 'Maksimum servicegebyr',
      tooltip: 'Servicegebyret overstiger aldrig dette beløb, uanset ordreværdien.',
    },
  },
  limits:
    "Skal holdes inden for FoodAmigos' grænser: maks. {{max_percentage}} % / {{max_amount}}, minimum mindst {{min_amount}}.",
  not_charged_notice:
    'Der opkræves ikke servicegebyr på denne restaurant lige nu. Gem et gebyr nedenfor for at slå det til.',
  zero_percentage_warning:
    'En procentdel på 0 % deaktiverer ikke servicegebyret: beregnede gebyrer under minimumsbeløbet rundes op til det, så hver ordre opkræves stadig mindst minimumsbeløbet.',
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
    reset_to_default: 'Nulstil til partnerstandard',
    turn_off: 'Slå servicegebyr fra',
  },
  toasts: {
    load_error: 'Servicegebyrindstillingerne kunne ikke indlæses.',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
    reset_to_default: 'Tilsidesættelse fjernet — partnerstandarden gælder.',
    reset_to_default_skipped: 'Tilsidesættelse fjernet — der opkræves intet servicegebyr, før du gemmer et.',
    turned_off: 'Servicegebyr slået fra. Dine værdier gemmes, til du slår det til igen.',
  },
};
